const config = {
  routes: {
    label: 'Terms',
    prefix: '/terms',
  },
}

export default config
